/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Box, Flex, useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import { useMemo } from 'react';
import { gql, useMutation } from '@apollo/client';
import TextAreaFormField from '../../../components/form/TextAreaFormField';
import FileFormField from '../../../components/form/FileFormField';
import c from '../../../constant';
import * as Yup from 'yup';

const M_SIGNNP_MISC = gql`
	mutation addSignNpMiscellaneous($signId: String!, $description: String!, $attachmentFile: Upload, $attachmentFileSize: Float) {
		addSignNpMiscellaneous(signId: $signId, description: $description, attachmentFile: $attachmentFile, attachmentFileSize: $attachmentFileSize) {
			id
			createdAt
			userCreatedBy {
				id
				username
				fullName
				fullNameKhmer
				avatar
			}
			createdBy
			position
			reviewer
			userReviewer {
				id
				username
				fullName
				fullNameKhmer
				avatar
			}
			decision
			decisionAt
			signature
			miscellaneous
			decisionFile
		}
	}
`;

const maxFileSize = 104857600 / 20; // 5MB

function Create({ signData = null, onClose = () => null, onComplete = () => null }) {
	const toast = useToast();
	const { t } = useTranslation();
	const [createRecord, { loading }] = useMutation(M_SIGNNP_MISC);

	const validationSchema = useMemo(
		() =>
			Yup.object().shape({
				description: Yup.string().required('required'),
				attachment: Yup.mixed()
					.test('fileSize', 'over limit', (value) => {
						if (value) {
							return value?.size <= maxFileSize;
						} else {
							return true;
						}
					})
					.required('required'),
			}),
		[]
	);

	return (
		<Modal size="xl" closeOnEsc={!loading} closeOnOverlayClick={!loading} isOpen={true} onClose={onClose}>
			<ModalOverlay />
			<ModalContent borderRadius={c.borderRadius}>
				<ModalHeader pb={0} mb={0}>
					{t('Miscellaneous')}
				</ModalHeader>
				<ModalCloseButton isDisabled={loading} />
				<ModalBody>
					<Formik
						initialValues={{
							description: '',
							attachment: null,
						}}
						validationSchema={validationSchema}
						onSubmit={(values) => {
							const description = values?.description || '';
							const attachmentFile = values?.attachment || null;
							const attachmentFileSize = values?.attachment?.size || 0;
							const variables = {
								signId: signData?.id,
								description,
								attachmentFile,
								attachmentFileSize,
							};
							createRecord({ variables })
								.then(({ data }) => {
									onClose();
									onComplete(data?.addSignNpMiscellaneous);
								})
								.catch((error) => {
									if (error?.graphQLErrors?.length > 0) {
										error?.graphQLErrors.map(({ message }, i) =>
											toast({
												title: t(message),
												status: 'error',
												isClosable: true,
												position: 'bottom-right',
											})
										);
									} else {
										toast({
											title: t(error?.message ? error?.message : 'something went wrong'),
											status: 'error',
											isClosable: true,
											position: 'bottom-right',
										});
									}
								});
						}}
					>
						{({ values }) => (
							<Form>
								<Box mt="2">
									<>
										<TextAreaFormField name="description" label="Description (eg. mission, on leave)" required={true} />
									</>
									<>
										<FileFormField name="attachment" label="Attachment" required={true} />
									</>
									<>
										<Flex flex="1" mt="6" mb={2} justifyContent="flex-end" alignItems="center">
											<Button type="submit" isLoading={loading} borderRadius={c.borderRadius} colorScheme="blue" onMouseDown={() => null}>
												{t('Submit')}
											</Button>
										</Flex>
									</>
								</Box>
							</Form>
						)}
					</Formik>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}

export default Create;
